import { render, staticRenderFns } from "./oneboxing.vue?vue&type=template&id=25ca3e1b&scoped=true"
import script from "./oneboxing.vue?vue&type=script&lang=js"
export * from "./oneboxing.vue?vue&type=script&lang=js"
import style0 from "./oneboxing.vue?vue&type=style&index=0&id=25ca3e1b&prod&scoped=true&lang=css"
import style1 from "./oneboxing.vue?vue&type=style&index=1&id=25ca3e1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ca3e1b",
  null
  
)

export default component.exports